import logo from './icons8-voltage-64.png'
import Buttons from './Buttons'
import {useState} from 'react'
import Web3 from 'web3'

//This is the functional component containing the header and information
function Header(props) {

    const [userAddress, setUserAddress] = useState('')
    const [error, setError] = useState()
    const preinstalledNetworks = ['ethereum', 'rinkeby', 'ropsten', 'goerli', 'kovan']

    //Random network configurations for adding to Metamask (Note that, preinstalled
    //ones such as Rinkeby, Eth mainnet can't be added again)
    const networks = {
        rinkeby: {
            chainId: `0x${Number(4).toString(16)}`,
            chainName: "Rinkeby",
            nativeCurrency: {
                name: 'ETHEREUM',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: ["https://rinkeby.infura.io/v3/0c5d6c9b83ce42928bcea56fed32b12b"],
            blockExplorerUrls: ["https://rinkeby.etherscan.io"]
        },
        goerli: {
            chainId: `0x${Number(5).toString(16)}`,
            chainName: "Goerli",
            nativeCurrency: {
                name: 'ETHEREUM',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: ["https://goerli.infura.io/v3/0c5d6c9b83ce42928bcea56fed32b12b"],
            blockExplorerUrls: ["https://goerli.etherscan.io"]
        },
        polygon: {
            chainId: `0x${Number(137).toString(16)}`,
            chainName: "Polygon Mainnet",
            nativeCurrency: {
                name: 'MATIC',
                symbol: 'MATIC',
                decimals: 18
            },
            rpcUrls: ["https://polygon-rpc.com/"],
            blockExplorerUrls: ["https://polygonscan.com"]
        }
    }
    
    //This is a function used for changing the network on Metamask
    const changeNetwork = async ({networkName, setError}) => {
        try {
            if (!window.ethereum) throw new Error("No crypto wallet found");
            if (preinstalledNetworks.includes(networkName)) {
                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{chainId: `0x${Number(5).toString(16)}`}]
                })
            }
            else {
                await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            ...networks[networkName]
                        }
                    ]
                });
            }
        }
        catch (err) {
            setError(err.message)
            console.log(error)
        }
    }

    //This function is only invoked when network is not on the default network- Goerli
    //It is used to switch back the network to Goerli.
    const handleNetworkSwitch = async (networkName) => {
        await connectWallet()
        await changeNetwork({networkName, setError})
        await changeConnectState()
        await mouseMoveFunc()
    }

    //This function is implored to connect user wallet to this site
    const connectWallet = async() => {
        if (window.ethereum && window.ethereum.isMetaMask) {

            window.web3 = new Web3(window.ethereum)
            try {
                await window.ethereum.request({method: 'eth_requestAccounts'})
                const accounts = await window.ethereum.request({method: 'eth_requestAccounts'})
                setUserAddress(accounts[0])
                props.onConnect(accounts[0])
                if (window.ethereum.networkVersion !== '5') {
                    console.log('You are on a wrong network, please switch to Goerli')
                }
            }
            catch (error) {
                console.log('OOPS! You aren\'t connected, mate')
                return ('YOU ARE NOT CONNECTED TO METAMASK')
            }
        }
    }

    const [testOptions, setTestOptions] = useState('')
    const [connectState, setConnectState] = useState(false)
    const [testOptions_, setTestOptions_] = useState('')

    //This is simple function to change the connectState react variable
    const changeConnectState = async() => {
        if (connectState === false && testOptions !== 'disconnect') {
            await connectWallet()
            setConnectState(true)
        }
        else if (connectState === true && testOptions !== 'disconnect') {
            await connectWallet()
        }
        await checkMintableFunc(true)
        await mouseMoveFunc()
    }

    // This function also manipulates the connectState when 'disconnect' is clicked
    const changeDisconnectState = async() => {
        if (testOptions === 'disconnect') {
            setConnectState(false)
            setTestOptions('')
        }
    }

    //This function is implored when the mouse or cursor rolls over the connection section
    //It gives an external parent function the current value of 'testOptions_'
    const mouseMoveFunc = async() => {
        if (testOptions_ === 'disconnect' && connectState === true) {
            props.onAccess(testOptions_)
        }
    }

    //This function takes in value of an option in the selection tag as selected
    //by the user and outputs it into an external, parents function i.e. props.onAccess()
    const testOptionsFunc = async(e) => {
        setTestOptions(e.target.value)
        setTestOptions_(e.target.value)
        props.onAccess(e.target.value)
    }

    //This function simply outputs the connectState for an external parent function
    //to check if it is allowed for user to mint (only when a wallet is connected)
    async function checkMintableFunc (connectState) {
        await props.onCheckMintable(connectState)
    }

    return (
        <header className='header'>
            <div>
                <title>Mystic Creatures</title>
                <div className='header-column'>
                    <a href='http://localhost:3000'>
                        <img src= {logo} alt="logo"/>
                    </a>
                </div>
                <div className='header-column'>
                    <h1 id='header-name'>Mystic Creatures</h1>
                </div>
                <div id='connection' className='header-column'>
                    {(window.ethereum.networkVersion === '5') ?
                    <Buttons id='connectButton' onClick={changeConnectState} 
                    onSet={changeDisconnectState}
                    title={(connectState === false) ? 'Connect Wallet' : 
                        (<form style={{display: 'flex'}} type='submit'>
                            <select name='dropdown' id='user-address' onChange={testOptionsFunc} defaultValue={userAddress}>
                                <option id='just-address' hidden>{userAddress}</option>
                                <option value='copy' id='indi'>copy</option>
                                <option value='disconnect'>disconnect</option>
                            </select>
                        </form>)
                    }/> :
                    <Buttons id='switchButton' onClick={() => {handleNetworkSwitch("goerli")} } 
                     onSet={changeDisconnectState}
                    title={(connectState === false) ? 'Connect Wallet' : 
                        (<form style={{display: 'flex'}} type='submit'>
                            <select name='dropdown' id='user-address' onChange={testOptionsFunc} defaultValue={userAddress}>
                                <option id='just-address' disabled hidden>{userAddress}</option>
                                <option value='copy' id='indi'>copy</option>
                                <option value='disconnect'>disconnect</option>
                            </select>
                        </form>)
                    }
                    />
                    }
                </div>
            </div>
        </header>
    )
}

export default Header